<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="名称">
              <a-input v-model="queryParam.name" placeholder="名称" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="编码">
              <a-input v-model="queryParam.code" placeholder="编码" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleAdd">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelet(record)"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import { Dictionaries } from '@/common/AllConstant'
import CreateForm from '../modules/CreateForm'
import { product_parameter_list, product_parameter_create, product_parameter_delete } from '@/api/trade_product_parameter'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm
  },
  data () {
    return {
      loading: false,
      confirmLoading: false,
      dictionaries: Dictionaries,
      // 创建窗口控制
      visible: false,
      mdl: {
        empty: true,
        name: ''
      },
      // 高级搜索 展开/关闭
      advanced: false,
      parameterVisible: false,
      // 查询参数
      queryParam: {
        category_id: undefined
      },
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '名称',
          dataIndex: 'name',
          width: 200,
          ellipsis: true
        },
        {
          title: '符号',
          dataIndex: 'symbol',
          width: 160,
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.trade_value_compare_symbol[text] || '无'
        },
        {
          title: '值',
          dataIndex: 'standard_value',
          width: 160,
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        this.queryParam.category_id = this.$route.params.category_id
        return product_parameter_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            this.mdl.empty = !(res.data.entries.length > 0)
            return res.data
          })
      }
    }
  },
  methods: {
    handleAdd () {
      this.queryParam.category_id = this.$route.params.category_id
      this.mdl.name = this.$route.query.name
      this.visible = true
    },
    handleBatchAdd () {
      console.log('批量创建')
    },
    handleAddCancel () {
      this.visible = false

      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleEdit (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/' + this.$route.params.category_id + '/product_parameter/' + record.id })
    },
    handleDelet (record) {
      product_parameter_delete(record.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleOk (data) {
      const form = this.$refs.createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, data)
          if (data !== undefined && data.length > 0) {
            values = {
              multi: true
            }
            values['parameters'] = data.filter(item => {
              if (item['name'] === undefined || item['name'] === '') {
                return false
              } else if (item['symbol'] === undefined || item['symbol'] === '') {
                return false
              } else if (item['standard_value'] === undefined || item['standard_value'] === '') {
                return false
              }
              return true
            }).map(item => {
              item['category_id'] = this.$route.params.category_id
              item['key'] = undefined
              return item
            })
            if (values['parameters'].length !== data.length) {
              this.confirmLoading = false
              this.$message.warning('填写空的数据')
              return
            }
          } else {
            // 新增
            values['multi'] = false
            values['category_id'] = this.$route.params.category_id
          }
          product_parameter_create(values).then(res => {
              this.visible = false
              // 重置表单数据
              form.resetFields()
              // 刷新表格
              if (res.code === 1000) {
                this.$refs.table.refresh()
              }
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    }
  }
}
</script>
